module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("foaYQ"))).then(() => parcelRequire('kcp5P'));